export default __webpack_public_path__ + "media/gallery/gstar-6c7f36b8.jpg";